import api from '@/api/index.js'

const reporting_profiles = {
  state: {
    loading: false,
    data: [],
    error: null,
  },

  mutations: {
    SET_REPORTING_PROFILES: (state, profiles) => {
      state.data = profiles
      state.loading = false;
    },
    SET_REPORTING_PROFILES_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_REPORTING_PROFILES_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
  },

  actions: {
    LoadReportingProfiles({commit}) {
      commit('SET_REPORTING_PROFILES_ERROR', null)
      commit('SET_REPORTING_PROFILES_LOADING', true)
      return api.get('reporting-profiles?limit=0&offset=0')
        .then((response) => {
          commit('SET_REPORTING_PROFILES', response)
          commit('SET_REPORTING_PROFILES_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ERROR', error)
          commit('SET_REPORTING_PROFILES_ERROR', error)
        })
    }
  }
}

export default reporting_profiles
